/**
 * Logging API endpoints.
 * Each function returns the factory-created methods bound to the axiosInstance.
 *
 * @param {import('axios').AxiosInstance} axiosInstance
 */
export default function loggingApi(axiosInstance) {
    const baseUrl = axiosInstance.defaults?.baseURL ?? '';
    const reportingBasePath = baseUrl.replace(/\/$/, '').toLowerCase().endsWith('/api') ? '' : '/api';

    return {
        getLiveData: () => axiosInstance.get(`${reportingBasePath}/Reporting/LiveData`),
        getLogs: (applicationName, duration, unit) => axiosInstance.get(`${reportingBasePath}/Reporting/Logs`, {
            params: {
                ApplicationName: applicationName,
                Duration: duration,
                Unit: unit,
            },
        }),
    };
}
